class Status {
    static delivery(val) {
        switch (val) {
            case "arrival":
                return {
                    text:'入荷中',
                    class: 'status_wait'
                };
            case "delivered":
                return {
                    text:'納品完了',
                    class: 'status_complete'
                };
            default:
                return {
                    text: val,
                    class: ''
                };
        }
    }

    static invoice(val) {
        switch (val) {
            case "unpaid":
                return {
                    text:'未入金',
                    class: 'status_alert'
                };
            case "paid":
                return {
                    text:'入金済',
                    class: 'status_complete'
                };
            case "prepare_refund":
                return {
                    text:'返金対応中',
                    class: 'status_alert'
                };
            case "refund":
                return {
                    text:'返金済',
                    class: 'status_complete'
                };

            default:
                return {
                    text: val,
                    class: ''
                };
        }
    }

    static order(val) {
        switch (val) {
            case "pending-verification":
                return {
                    text:'注文確認',
                    class: 'status_alert'
                };
            case "waiting-payment":
                return {
                    text:'決済待',
                    class: 'status_alert'
                };
            case "active":
                return {
                    text:'稼働中',
                    class: 'status_wait'
                };
            case "completed":
                return {
                    text:'完了',
                    class: 'status_complete'
                };
            case "canceled":
                return {
                    text:'キャンセル・却下',
                    class: ''
                };
            default:
                return {
                    text: val,
                    class: ''
                };
        }

    }

}


export default Status;